<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="projetos"
      :sort-by="[{ key: 'id', order: 'asc' }]"
      :search="search"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >Meus Projetos</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="flex">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              outline
              no-resize
              hide-details
              variant="underlined"
              style="width: 40%"
            ></v-text-field>
          </div>
          <v-divider class="mx-4" inset vertical></v-divider>

          <!-- Visualizar Projeto -->
          <v-dialog v-model="dialog" max-width="700px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Visualizar Projeto</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        v-model="editedItem.nome"
                        variant="underlined"
                        label="Nome"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="editedItem.sigla"
                        variant="underlined"
                        label="Sigla"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Equipe {{ this.nomeDaEquipe[0] }}</v-label>
                      <v-container class="d-flex" v-if="isLoading">
                        <v-skeleton-loader
                          class="skeleton-wrapper"
                          type="list-item-two-line"
                          :loading="isLoading"
                          v-for="index in 3"
                          :key="index"
                        ></v-skeleton-loader>
                      </v-container>

                      <v-card class="my-4">
                        <v-card-text>
                          <v-list
                            class="d-flex flex-wrap"
                            :min-width="150"
                            lines="one"
                          >
                            <v-list-item
                              v-for="item in equipeMembros"
                              :key="item.nomeEqui"
                              :title="item.nomeEqui"
                              :subtitle="
                                item.formaAtuacao === 'SCRUM_MASTER'
                                  ? 'SCRUM MASTER'
                                  : item.formaAtuacao
                              "
                            ></v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Stakeholders</v-label>
                      <br />
                      <v-container class="d-flex" v-if="isLoading">
                        <v-skeleton-loader
                          class="skeleton-wrapper"
                          type="list-item-two-line"
                          :loading="isLoading"
                          v-for="index in 4"
                          :key="index"
                        ></v-skeleton-loader>
                      </v-container>
                      <v-list
                        class="d-flex flex-wrap"
                        :min-width="150"
                        lines="two"
                        v-if="stakeholders.length > 0"
                      >
                        <v-list-item
                          v-for="item in stakeholders"
                          :key="item.nome"
                          :title="item.nome"
                          :subtitle="`${item.email}`"
                        ></v-list-item>
                      </v-list>
                      <p v-if="this.messageStake != ''">
                        {{ this.messageStake }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Repositórios</v-label>
                      <v-container class="d-flex" v-if="isLoading">
                        <v-skeleton-loader
                          class="skeleton-wrapper"
                          type="list-item-two-line"
                          :loading="isLoading"
                          v-for="index in 3"
                          :key="index"
                        ></v-skeleton-loader>
                      </v-container>
                      <v-list
                        class="d-flex flex-wrap"
                        :min-width="150"
                        lines="one"
                        v-else-if="repositorios.length > 0"
                      >
                        <v-list-item
                          v-for="repositorio in repositorios"
                          :key="repositorio.tb_repositorio.id_repositorio"
                          :title="repositorio.tb_repositorio.nome"
                          :link="true"
                          @click="redirect(repositorio.tb_repositorio.url)"
                          :subtitle="`${repositorio.tb_repositorio.owner}`"
                          elevation="2"
                          class="repo-item"
                        ></v-list-item>
                      </v-list>
                      <p v-else>
                        {{ this.messageRepo }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="editedItem.descricao"
                        variant="underlined"
                        label="Descrição"
                        readonly
                        no-resize
                        rows="2"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row class="justify-content-center mb-6">
                    <v-col cols="12">
                      <v-tooltip
                        location="bottom"
                        text="Consultar evolução individual"
                      >
                        <template #activator="{ props }">
                          <v-btn
                            prepend-icon="mdi-chart-line"
                            class="mr-4"
                            v-bind="props"
                            elevation="6"
                            @click="
                              this.$router.push({
                                name: 'evolucao/membros',
                                params: { id: parseInt(this.idProjeto) },
                              })
                            "
                            >Evolução Individual</v-btn
                          >
                        </template>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="justify-content-center">
          <RouterLink
            :to="'/projects/' + item.raw.idproj"
            style="text-decoration: none; color: inherit"
          >
            <v-tooltip text="Requisitos" location="bottom">
              <template #activator="{ props }">
                <v-icon
                  size="small"
                  v-bind="props"
                  class="me-2"
                  @click="funcaoReq(item.raw)"
                >
                  mdi-arrow-top-right-thin-circle-outline
                </v-icon>
              </template>
            </v-tooltip>
          </RouterLink>
        </div>
      </template>
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem projetos a listar </span>
        </div>
      </template>
      <!-- <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    VSkeletonLoader,
    SnackBar,
  },
  data: () => ({
    dialog: false,
    sprintDialog: false,
    listaRepositorios: [], // todos os repos da org
    listaRepositoriosAssoc: [], // repositórios já associados ao projeto
    repositorios: [], // todas as infos dos repos
    stakeholders: [], // stakeholders do projeto
    messageStake: '',
    messageRepo: '',
    headers: [
      {
        title: '#',
        align: 'start',
        key: 'id',
      },
      { title: 'Sigla', key: 'sigla' },
      { title: 'Nome', key: 'nome' },
      { title: 'Status', key: 'flencerrado' },
      { title: 'Ações', key: 'actions', sortable: false },
    ],
    projetos: [],
    idProjeto: null,
    equipeMembros: [],
    nomeDaEquipe: [],
    editedIndex: -1,
    editedItem: {
      sigla: '',
      nome: '',
      flencerrado: '',
      descricao: '',
    },
    defaultItem: {
      sigla: '',
      nome: '',
      flencerrado: '',
      descricao: '',
    },
    isLoading: true,
    search: '',
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.fetchprojetos();
  },

  methods: {
    retornaIdProj(item) {
      this.idProjeto = item.idproj;
      this.$router.push({
        name: 'ratingScrum',
        params: { id: parseInt(this.idProjeto) },
      });
    },
    retornaIdProjSprints(item) {
      this.idProjeto = item.idproj;
      this.$router.push({
        name: 'sprint',
        params: { id: parseInt(this.idProjeto) },
      });
    },
    retornaIdProjTarefas(item) {
      this.idProjeto = item.idproj;
      this.$router.push({
        name: 'tasks/backlog',
        params: { id: parseInt(this.idProjeto) },
      });
    },
    funcaoReq(item) {
      this.idProjeto = item.idproj;
    },
    // Função de inicialização de projeto, sempre preenche com uma req ao back
    /* eslint-disable */
    /**
     * Busca a lista de projetos a partir do backend e preenche o array de projetos
     * @function
     * @name fetchprojetos
     * @memberof TelaListarProj
     * @returns {Promise<void>}
     */
    fetchprojetos() {
      axios
        .get(API_URL + '/projetos/TESTADOR', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          let count = 1;
          response.data.forEach((element) => {
            /* eslint-disable */
            element.fl_coordenador === true
              ? (element.fl_coordenador = 'Coordenador')
              : (element.fl_coordenador = 'Desenvolvedor');
            /* eslint-enable */
            this.projetos.push({
              id: count++,
              idproj: element.id_projeto,
              sigla: element.sigla,
              nome: element.nome,
              flencerrado: element.flencerrado ? 'Encerrado' : 'Ativo',
              descricao: element.descricao,
              idEquipe: element.id_equipe_fk,
            });
          });
          localStorage.setItem(
            'idProjectList',
            JSON.stringify(this.projetos.map((item) => item.idproj)),
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
    /* eslint-disable */
    /**
     * Faz uma requisição GET para a API de membros de uma equipe e adiciona as informações relevantes de cada membro em um objeto.
     *
     * @function fetchEquipe
     * @param {string} equipe - O nome da equipe para a qual os membros serão listados.
     * @async
     * @returns {Promise<void>}
     */
    fetchEquipe(equipe) {
      axios
        .get(`${API_URL}/equipes/${equipe}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.isLoading = false;
          response.data.forEach((equi) => {
            this.equipeMembros.push({
              nomeEqui: equi.nome,
              formaAtuacao: equi.forma_atuacao,
              nomeEq: equi.nome_equipe,
            });
          });
          this.nomeDaEquipe = this.equipeMembros.map(function (n) {
            return n.nomeEq;
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    /**
     * Atualiza o estado de um item selecionado para ser editado e abre um diálogo para exibir as informações do item. Também faz uma requisição para obter os membros da equipe do item selecionado.
     *
     * @function showItem
     * @param {object} item - O objeto do item selecionado.
     * @returns {void}
     */
    showItem(item) {
      console.log('Dados: ', item);
      this.editedIndex = this.projetos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.idProjeto = item.idproj;
      this.fetchEquipe(item.idEquipe);
      this.fetchRepositorios(item.idproj);
      this.fetchStakeholders(item.idproj);
    },

    /**
     * Fecha o diálogo de visualizar de item e reseta o estado do item editado e da lista de membros da equipe.
     *
     * @function close
     * @returns {void}
     */
    close() {
      this.dialog = false;
      this.isLoading = true;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.equipeMembros = [];
        this.stakeholders = [];
      });
    },

    redirect(url) {
      window.open(url, '_blank');
    },

    fetchRepositorios(idProjeto) {
      this.messageRepo = '';
      axios
        .get(API_URL + `/projetos/${idProjeto}/repositorios`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          console.log(response.data);
          console.log(response.data.tb);
          this.repositorios = response.data;
          this.listaRepositoriosAssoc = this.repositorios.map(function (item) {
            return item.tb_repositorio.nome;
          });

          if (this.listaRepositoriosAssoc.length === 0) {
            this.messageRepo =
              'Esse projeto ainda não foi associado a um repositório.';
          }
        })
        .catch((error) => {
          this.messageRepo = 'Sem repositórios a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar os repositórios!'
          );
        });
    },

    fetchStakeholders(idProjeto) {
      this.messageStake = '';
      axios
        .get(API_URL + `/projetos/projetostakeholder/${idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          console.log(response.data);
          this.stakeholders = response.data.tb_projeto_stakeholder.map(
            function (item) {
              return {
                nome: item.tb_stakeholder_externo.nome,
                email: item.tb_stakeholder_externo.email,
              };
            }
          );
        })
        .catch((error) => {
          console.error(error.response);
          this.messageStake = 'Não há stakeholders cadastrados neste projeto.';
        });
    },
  },
};
</script>
<style scoped>
.d-flex {
  display: flex;
  padding: 0;
}
.flex {
  display: flex;
  width: 30%;
  align-items: center;
}
.flex-wrap {
  flex-wrap: wrap;
}
.skeleton-wrapper {
  width: 33%;
  background: transparent;
}
.repo-item {
  padding: 10px;
  margin: 10px 5px;
}
</style>
